module.exports = __webpack_public_path__ + "img/vm.7b8c1831.svg";